import { useSearchParams, useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { XCircle, RefreshCw, ArrowLeft } from "lucide-react";
import { L } from "../lib/translations";

export default function PaymentCancelled() {
  const { lang } = useLanguage();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const tid = params.get("tid");

  return (
    <div className="min-h-screen flex items-center justify-center px-4"
      style={{ background: "var(--bg-primary)" }}>
      <div className="w-full max-w-sm text-center">
        <div className="w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-6"
          style={{ background: "rgba(239,68,68,0.08)", border: "1.5px solid rgba(239,68,68,0.2)" }}>
          <XCircle className="w-10 h-10" style={{ color: "#ef4444" }} />
        </div>

        <h1 className="text-2xl font-black font-outfit mb-2" style={{ color: "var(--text-primary)" }}>
          {L(lang, "Payment Cancelled", "Оплата отменена", "התשלום בוטל")}
        </h1>
        <p className="text-sm mb-8" style={{ color: "var(--text-secondary)" }}>
          {L(lang,
            "No charges were made. You can try again whenever you're ready.",
            "Списаний не было. Попробуйте снова, когда будете готовы.",
            "לא בוצע חיוב. תוכל לנסות שוב מתי שתרצה."
          )}
        </p>

        {tid && (
          <div className="px-3 py-2 rounded-xl text-xs mb-6 font-mono"
            style={{ background: "var(--surface-2)", border: "1px solid var(--border-color)", color: "var(--text-secondary)" }}>
            ref: {tid.slice(-8).toUpperCase()}
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={() => navigate("/test2")}
            className="w-full h-12 font-bold text-sm flex items-center justify-center gap-2 press-btn"
            style={{ borderRadius: 9999, background: "linear-gradient(135deg,#8B5CF6,#4F46E5)", color: "#fff", boxShadow: "0 4px 20px rgba(139,92,246,0.3)" }}>
            <RefreshCw className="w-4 h-4" />
            {L(lang, "Try Again", "Попробовать снова", "נסה שוב")}
          </button>
          <button
            onClick={() => navigate("/dashboard")}
            className="w-full h-11 font-semibold text-sm flex items-center justify-center gap-2 press-sm"
            style={{ borderRadius: 9999, background: "var(--surface-2)", border: "1px solid var(--border-color)", color: "var(--text-secondary)" }}>
            <ArrowLeft className="w-4 h-4 rtl-flip" />
            {L(lang, "Back to Account", "Вернуться в аккаунт", "חזור לחשבון")}
          </button>
        </div>
      </div>
    </div>
  );
}
